import { HttpClient, HttpContext } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { TransactionTypeEnum } from '@helios/common-api'
import {
  ERROR_INTERCEPTOR_BYPASS,
  HANDLE_ERROR_AND_THROW,
  HELIOS_COMMAND_HTTP_TOKEN,
} from '@helios/utils'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import {
  BULK_CW_TRAN_LIMIT,
  BulkClearwaterTransactionsGetRequest,
  BulkClearwaterTransactionsGetResponse,
  BulkClearwaterTransactionsUpdateResponse,
  BulkClearwaterTranSetValues,
  BulkCwTranTypeSetValue,
  UpdateBulkClearwaterTransactionsForm,
} from '../models/bulk-clearwater-transactions.model'

export const BULK_CW_TX_URL = `helios-bulk-cw-transactions`
export const BULK_CW_TX_SET_VALUES_URL = `${BULK_CW_TX_URL}/setValues`

@Injectable({
  providedIn: 'root',
})
export class BulkClearwaterTransactionsService {
  constructor(private readonly http: HttpClient) {}

  updateBulkClearwaterTransactions(
    request: UpdateBulkClearwaterTransactionsForm,
  ): Observable<BulkClearwaterTransactionsUpdateResponse> {
    return this.http.put<BulkClearwaterTransactionsUpdateResponse>(
      BULK_CW_TX_URL,
      request,
      {
        context: new HttpContext()
          .set(HANDLE_ERROR_AND_THROW, true)
          .set(HELIOS_COMMAND_HTTP_TOKEN, true),
      },
    )
  }

  getBulkClearwaterTransactions(
    request: BulkClearwaterTransactionsGetRequest,
  ): Observable<BulkClearwaterTransactionsGetResponse> {
    return this.http
      .post<BulkClearwaterTransactionsGetResponse>(BULK_CW_TX_URL, request, {
        params: {
          maxBulkCwTrans: BULK_CW_TRAN_LIMIT,
        },
        context: new HttpContext()
          .set(ERROR_INTERCEPTOR_BYPASS, [503])
          .set(HANDLE_ERROR_AND_THROW, true),
      })
      .pipe(
        map(x => {
          return {
            ...x,
            data: x.data.map(y => ({
              ...y,
              entryDate:
                y.entryDate &&
                (new Date(y.entryDate + '') as unknown as string),
              settleDate:
                y.settleDate &&
                (new Date(y.settleDate + '') as unknown as string),
              postDate:
                y.postDate && (new Date(y.postDate + '') as unknown as string),
              clearedDate:
                y.clearedDate &&
                (new Date(y.clearedDate + '') as unknown as string),
              createdDate:
                y.createdDate &&
                (new Date(y.createdDate + '') as unknown as string),
              modifiedDate:
                y.modifiedDate &&
                (new Date(y.modifiedDate + '') as unknown as string),
              originationFee: y.dataMap?.['originationFee']
                ? Number(y.dataMap['originationFee'])
                : undefined,
              prepaidInterest: y.dataMap?.['prepaidInterest']
                ? Number(y.dataMap['prepaidInterest'])
                : undefined,
              interestDue: y.dataMap?.['interestDue']
                ? Number(y.dataMap['interestDue'])
                : undefined,
              isCapitalize:
                y.dataMap?.['isCapitalize'] != null
                  ? Boolean(y.dataMap['isCapitalize'])
                  : undefined,
            })),
          }
        }),
      )
  }

  getTransactionTypes(): Observable<BulkCwTranTypeSetValue[]> {
    return this.http
      .get<BulkClearwaterTranSetValues>(BULK_CW_TX_SET_VALUES_URL)
      .pipe(
        map(res =>
          res.tranTypes.map(type => ({
            type,
            name: TransactionTypeEnum[type],
          })),
        ),
      )
  }
}
